(() => {
  if (!document.documentElement.lang.startsWith('lt')) return;
  const observed = new WeakSet();
  const localizeChat = root => {
    const label = root.querySelector('[data-testid="widgetLabel"] > span');
    if (label && label.textContent.trim() === 'Chat with us') {
      const text = [...label.childNodes].find(node => node.nodeType === Node.TEXT_NODE);
      if (text) text.nodeValue = 'Parašykite mums ';
    }
    const button = root.querySelector('[data-testid="widgetButtonBody"]');
    if (button?.getAttribute('aria-label') === 'Open chat widget') button.setAttribute('aria-label', 'Atidaryti pokalbį');
  };
  const connectChat = () => {
    const root = document.getElementById('tidio-chat')?.shadowRoot;
    if (!root || observed.has(root)) return;
    observed.add(root);
    new MutationObserver(() => localizeChat(root)).observe(root, {childList:true,subtree:true});
    localizeChat(root);
  };
  new MutationObserver(connectChat).observe(document.body, {childList:true,subtree:true});
  document.addEventListener('tidioChat-ready', connectChat);
  connectChat();
})();
